import React from 'react';
import { Accordion } from '../../../../../../../components-dummy';
import { ExpandableSectionTrigger } from '../../../../../../../components-dummy/AccordionSideBar/components/ExpandableSectionTrigger';
import { useAccordionExpansion } from '../../../../../../../components-dummy/AccordionSideBar/hooks/useAccordionExpansion';
import { useExpandSelectionChange } from '../../../../../../../components-dummy/AccordionSideBar/hooks/useExpandSelectionChange';
import { HeaderSection } from './HeaderSection';
import { ButtonSection } from './ButtonSection';
import { ExpandableSection } from '../../../../../constants/expandable-section';
import { AccordionSection } from '../../../../../types';
import { WidgetMaker } from '../../../../../types/widget-maker';
import { CampaignDraft } from '../../../../../types/campaign-draft';
import { ParseJoiValidateResponse } from '../../../../../../../utils';
import { ProductCardSection } from './ProductCardSection/ProductCardSection';

interface EmailDisplaySettingsSectionProps {
  widgetMaker: Partial<WidgetMaker>;
  onChange: (campaign: CampaignDraft) => void;
  errors: ParseJoiValidateResponse<WidgetMaker>;
}

export const EmailDisplaySettingsSection = ({
  widgetMaker,
  onChange,
  errors,
}: EmailDisplaySettingsSectionProps) => {
  const { expandedSection, handleSectionToggle } = useAccordionExpansion(null);

  const sections: AccordionSection[] = [
    {
      id: ExpandableSection.Header,
      title: 'Widget Header',
      content: <HeaderSection widgetMaker={widgetMaker} onChange={onChange} errors={errors} />,
      isExpanded: expandedSection === ExpandableSection.Header,
    },
    {
      id: ExpandableSection.ProductCard,
      title: 'Product Card',
      content: <ProductCardSection widgetMaker={widgetMaker} onChange={onChange} errors={errors} />,
      isExpanded: expandedSection === ExpandableSection.ProductCard,
    },
    {
      id: ExpandableSection.Button,
      title: 'Widget Button',
      content: <ButtonSection widgetMaker={widgetMaker} onChange={onChange} errors={errors} />,
      isExpanded: expandedSection === ExpandableSection.Button,
    },
  ];

  const { onExpandSelectionChange } = useExpandSelectionChange({
    sections,
    setExpendedSection: handleSectionToggle,
  });

  return (
    <Accordion
      onSelectionChanged={onExpandSelectionChange}
      expandedIds={sections.filter(section => section.isExpanded).map(section => section.id)}
    >
      {sections.map(({ id, title, content, isExpanded, isDisabled }) => (
        <Accordion.Item key={id} id={id} observeHeight>
          <Accordion.Item.Header>
            <ExpandableSectionTrigger
              title={title}
              isExpanded={isExpanded}
              isDisabled={isDisabled}
              className='email-display-section'
            />
          </Accordion.Item.Header>
          <Accordion.Item.Content>{content}</Accordion.Item.Content>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
